import type { StateCreator } from 'zustand';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FilterSilobagList = any;

export type FilterSlice = {
  // [PROPS]
  filter_silobag_list: FilterSilobagList;

  // [METHODS]
  filter_set_silobag_list: (silobag_list: FilterSilobagList) => void;
  filter_clear: () => void;
};

export const createFilterSlice: StateCreator<FilterSlice, [], [], FilterSlice> = (set) => ({
  // [PROPS]
  filter_silobag_list: [],

  // [METHODS]
  filter_set_silobag_list: (silobag_list) => set({ filter_silobag_list: silobag_list }),
  filter_clear: () => set({ filter_silobag_list: [] }),
});
